import {request_async} from "@/utils/requestAsync";
import {API_URL_ERP} from "@/model/ConfigModel";
// 直接生成erp平台，实验平台教师用户expTeacher的token
export async function generateErpExpTeacherToken(data) {
  return request_async(API_URL_ERP + "/v1/adminUser/generateErpExpTeacherToken", "get", data);
}
